import React, { useEffect, useState } from 'react'
import { get } from '../../util/request'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { format } from 'date-fns'

const ListTugasKerja = () => {
  const [tab, setTab] = useState('')

  const [state, setState] = useState({
    tasksList: '',
    myTask: 0,
    loading: true
  })

  const jwtToken = useSelector(state => state.auth.generateToken)
  const user = useSelector(state => state.auth.user)
  const { id } = useParams()

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      var url = `public/api/v2/task-list?company_id=${user.company_id}&company_project_id=${id}&employee_id=${user.employee_id}&my_task=${state.myTask}&report_status_id=${tab}`
      setState({
        ...state,
        loading: true
      })
      getTasksList(url)

    }
    return () => isMounted === false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab])

  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      var url = `public/api/v2/task-list?company_id=${user.company_id}&company_project_id=${id}&employee_id=${user.employee_id}&my_task=${state.myTask}&report_status_id=${tab}`
      setState({
        ...state,
        loading: true
      })
      getTasksList(url)

    }
    return () => isMounted === false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.myTask])


  const getTasksList = (url) => {
    get(
      url,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },
      },
      success => {
        setState(prevState => {
          return {
            ...prevState,
            tasksList: success.data.Data,
            loading: false
          }
        })
      },
      error => {
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  const formatDate = (date, time) => {
    const dt1 = new Date(date);
    var d1 = format(dt1, 'EEEE, dd MMMM yyyy')
    let hour = time.slice(0, 5);
    return d1 + " " + hour
  }

  const handleMytask = (e, val) => {
    setState({
      ...state,
      myTask: val
    })
  }

  return (
    state.loading ? '' :
      <div className='w-full h-screen grid-cols-1 bg-white sm:grid-cols-2'>
        <div className='w-full h-20 bg-real-white'>
          <div className='flex items-center justify-between h-full px-4'>
            <div className='flex items-center'>
              <a href={process.env.PUBLIC_URL + "/tugas-kerja"}>
                <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
              </a>
              <p className='px-4'>Daftar Tugas Kerja</p>
            </div>
            <div className=''>
              {state.myTask === 1 ? 
              <div onClick={(e) => handleMytask(e, 0) } className=" px-8 rounded-full bg-gradient-to-b from-red-light-bg to-orange-bg hover:bg-gradient-to-b hover:from-red-dark-bg hover:to-orange-dark-bg py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              All Tasks
            </div>
               : <div onClick={(e) => handleMytask(e, 1) } className=" px-8 rounded-full bg-gradient-to-b from-red-light-bg to-orange-bg hover:bg-gradient-to-b hover:from-red-dark-bg hover:to-orange-dark-bg py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
               My Tasks
             </div>
            
              }
              
            </div>
          </div>
        </div>
        <div className='w-full px-4 py-4 bg-real-white'>
          <div className="text-sm font-medium text-center text-gray-500 dark:text-gray-400 dark:border-gray-700">
            <ul className="flex -mb-px overflow-x-scroll">
              <li className="me-2">
                <p onClick={() => setTab(1)} className={`${tab === 1 || tab === "" ? " text-black border-b-2 border-black active" : ""} inline-block p-4 rounded-t-lg cursor-pointer `}>TODO</p>
              </li>
              <li className="me-2">
                <p onClick={() => setTab(2)} className={`${tab === 2 ? " text-black border-b-2 border-black active" : ""} inline-block p-4 rounded-t-lg cursor-pointer `}>RESOURCE</p>
              </li>
              <li className="me-2">
                <p onClick={() => setTab(3)} className={`${tab === 3 ? "  text-black border-b-2 border-black active" : ""} inline-block p-4 rounded-t-lg cursor-pointer `}>BACKLOG</p>
              </li>
              <li className="me-2">
                <p onClick={() => setTab(4)} className={`${tab === 4 ? "  text-black border-b-2 border-black active" : ""} inline-block p-4 rounded-t-lg cursor-pointer`}>INPROGRESS</p>
              </li>
              <li className="me-2">
                <p onClick={() => setTab(5)} className={`${tab === 5 ? "  text-black border-b-2 border-black active" : ""} inline-block p-4 rounded-t-lg cursor-pointer`}>FEEDBACK</p>
              </li>
              <li className="me-2">
                <p onClick={() => setTab(6)} className={`${tab === 6 ? "text-black border-b-2 border-black active" : ""} inline-block p-4 rounded-t-lg cursor-pointer`}>DONE</p>
              </li>

            </ul>
          </div>

        </div>

        <div className='w-full h-screen bg-white'>
          <div className='grid grid-cols-1'>
            {state.tasksList.map((item, index) => (
              <a href={process.env.PUBLIC_URL + "/tugas-kerja/" + id + "/" + item.company_task_id} key={index}>
                <div className="grid grid-cols-4 p-4 mx-4 mt-4 rounded-lg bg-real-white">
                  <div className='col-span-3'>
                    <p className='py-1 text-base font-bold'>{item.task_title}</p>
                    <p className='py-1 text-base'>{formatDate(item.end_date, item.end_time)}</p>
                    {item.is_overdue === 1 ?
                      <span className="inline-flex items-center px-3 py-1 text-xs font-medium text-white rounded-md ring-1 ring-inset ring-gray-500/10" style={{ backgroundColor: item.is_overdue_color }}>{item.status_text}</span>
                      : ''}
                  </div>
                  <div>
                    <div className="px-2 py-1 text-xs font-medium text-center text-black border rounded-md ring-1 ring-inset ring-gray-500/10" style={{ color: item.status.color, borderColor: item.status.color }}>{item.status.report_status_name}</div>
                    <br></br>
                    <div className='flex justify-end gap-2'>
                      <div className="w-8 h-8 py-2 text-xs font-medium text-center text-black border border-blue-600 rounded-full">UL</div>
                      <div className="w-8 h-8 py-2 text-xs font-medium text-center text-black border border-blue-600 rounded-full">WD</div>
                    </div>
                  </div>
                </div>
              </a>
            ))}




          </div>


        </div>


      </div >

  )
}

export default ListTugasKerja